import { render, staticRenderFns } from "./VSelectList.vue?vue&type=template&id=95a8b36e&"
import script from "./VSelectList.vue?vue&type=script&lang=js&"
export * from "./VSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports